import { render } from "./layout-horizontal-sidemenu.vue?vue&type=template&id=1371c1f3&scoped=true"
import script from "./layout-horizontal-sidemenu.vue?vue&type=script&lang=js"
export * from "./layout-horizontal-sidemenu.vue?vue&type=script&lang=js"

import "./layout-horizontal-sidemenu.vue?vue&type=style&index=0&id=1371c1f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1371c1f3"]])

export default __exports__